import { render, staticRenderFns } from "./ExpiredTasksIcon.vue?vue&type=template&id=4d2b3ad9&"
import script from "./ExpiredTasksIcon.vue?vue&type=script&lang=js&"
export * from "./ExpiredTasksIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports